import React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { store } from "./app/store"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import "./index.css"
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.js"
import GlobalErrorBoundary from "./features/common/GlobalErrorBoundary"

// Global error handling for unhandled promise rejections
window.addEventListener("unhandledrejection", (event) => {
  console.warn("Suppressed Promise Rejection:", event.reason)
  event.preventDefault() // Prevents error message
})

// Global error handling for runtime errors
window.addEventListener("error", (event) => {
  console.warn("Suppressed Error:", event.message)
  event.preventDefault()
})

// Get root element to render the app
const container = document.getElementById("root")

if (!container) {
  throw new Error("Root element not found")
}

const root = createRoot(container)

// Render the app within error boundaries
root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <Provider store={store}>
        <GlobalErrorBoundary>
          <App />
        </GlobalErrorBoundary>
      </Provider>
    </GlobalErrorBoundary>
  </React.StrictMode>
)

reportWebVitals()